import React from 'react';
import { Box, TextField, Button, Typography, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';

const FilterPanel = ({ search, onSearch, onReset, totalCount }) => {
    return (
        <Box
            sx={{
                mb: 2,
                p: 2,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                backgroundColor: 'background.paper'
            }}
        >
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                <TextField
                    placeholder="Search templates (min 2 chars)..."
                    value={search}
                    onChange={onSearch}
                    size="small"
                    sx={{ minWidth: 250, flexGrow: 1 }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        )
                    }}
                    helperText={search.length > 0 && search.length < 2 ? "Type at least 2 characters to search" : ""}
                />

                <Button
                    variant="outlined"
                    startIcon={<RefreshIcon />}
                    onClick={onReset}
                    sx={{ textTransform: 'none' }}
                >
                    Reset
                </Button>
            </Box>

            {/* Results count */}
            <Box sx={{ mt: 2 }}>
                <Typography variant="body2" color="text.secondary">
                    Total Templates: <strong>{totalCount}</strong>
                </Typography>
            </Box>
        </Box>
    );
};

export default FilterPanel;
